import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const PRPService = {
  async getPRP(page, perPage) {
    const params = generateQueryParams({
      page,
      size: perPage,
    });

    const res = await axios.get('limitvariables/', { params });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createPRP(data) {
    const res = await axios.post('limitvariables/', data);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },
  async editPRP(data, id) {
    const res = await axios.put(`limitvariables/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deletePRP(id) {
    const res = await axios.delete(`limitvariables/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
